<script lang="ts" setup>
  import { ref } from 'vue';
  import { useIntersectionObserver } from '@vueuse/core';
  import BcSpinner from '@/ui-kit/components/BcSpinner/BcSpinner.vue';
  
  const props = defineProps<{
    hasMore: boolean;
    isLoadingMore: boolean;
    threshold?: number;
    spinnerSize?: 'small' | 'medium' | 'large';
    rootMargin?: string;
  }>();
  
  const emit = defineEmits<{
    (e: 'load-more'): void
  }>();
  
  const triggerRef = ref<HTMLElement>();
  
  const defaultProps = {
    threshold: 0.1,
    spinnerSize: 'medium',
    rootMargin: '0px 0px 200px 0px'
  };
  
  // Set up the intersection observer
  useIntersectionObserver(
    triggerRef,
    ([{ isIntersecting }]) => {
      if (isIntersecting && props.hasMore && !props.isLoadingMore) {
        emit('load-more');
      }
    },
    { 
      threshold: props.threshold || defaultProps.threshold,
      rootMargin: props.rootMargin || defaultProps.rootMargin,
    }
  );
</script>

<template>
  <div class="w-full">
    <!-- Loading indicator -->
    <div v-if="props.isLoadingMore" class="flex justify-center py-4">
      <BcSpinner :size="props.spinnerSize || defaultProps.spinnerSize" />
    </div>
    
    <!-- Intersection observer target -->
    <div 
      v-if="props.hasMore" 
      ref="triggerRef" 
      class="trigger-element h-4 w-full min-h-4"
    />
  </div>
</template>
